export default __webpack_public_path__ + "locales/vi/PeopleTranslations.json?hash=d155d7cddbf6769f6f33e7d92e7792d7";